<template>
  <div>
    <v-dialog v-model="internalDialog" max-width="750px" persistent>
      <v-overlay :value="overlayMain">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-overlay :value="overlayComponent">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
      <v-card class="pa-3">
        <v-card-title class="d-flex justify-center">{{ languageSelect === 0 ? 'รายละเอียดแพ็คเกจ' : 'Package details' }}</v-card-title>
        <v-card-text>
          <v-select
            v-model="groupFlowId"
            :label="languageSelect === 0 ? 'ประเภทบริการ *' : 'Service *'"
            dense
            outlined
            :item-text="languageSelect === 0 ? 'text' : 'textEn'"
            :items="groupFlow"
            attach
            :menu-props="{ bottom: true, offsetY: true }"
            readonly
          ></v-select>
          <v-select
            v-model="flowId"
            :label="languageSelect === 0 ? 'แพ็คเกจ *' : 'Packages *'"
            :item-text="languageSelect === 0 ? 'text' : 'textEn'"
            dense
            outlined
            :items="DataFlow"
            attach
            :menu-props="{ bottom: true, offsetY: true }"
            readonly
          >
          <template slot="item" slot-scope="data">
              <p class="text-wrap" >{{languageSelect === 0 ? data.item.text : data.item.textEn}}</p>
          </template>
          </v-select>
        </v-card-text>
        <v-card-title class="mb-1 d-flex justify-center">{{ languageSelect === 0 ? 'ฉากที่เลือก' : 'Selected Scene' }}</v-card-title>
        <v-item-group
          v-model="selectedEmpList"
          mandatory
          multiple
        >
          <v-row>
            <v-col
              v-for="(emp,i) in selectedEmpDetailList"
              :key="i"
              cols="6"
              sm="6"
              md="6"
            >
              <v-item :value="emp.empId" v-slot="{ active, toggle }">
                <v-sheet
                  elevation="6"
                  class="pa-2"
                >
                <v-img
                  v-if="emp.empImge"
                  max-height="150"
                  max-width="250"
                  :src="emp.empImge"
                  @click="openDialogPreView(emp.picture[0].gallery)"
                ></v-img>
                <div
                  v-else
                  style="max-width: 250px; max-height: 150px; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; border: 1px dashed #ccc;"
                >
                  <v-icon
                    style="font-size: 96px;"
                  >
                  mdi-image-multiple
                  </v-icon>
                </div>
                  <div class="mt-2 d-flex align-center justify-space-between" @click="toggle">
                    <div>
                      <div class="font-weight-bold">
                        {{ languageSelect === 0 ? emp.empFull_NameTH : emp.empFull_NameEn }}
                      </div>
                      <div class="text--secondary">
                        {{ emp.empPosition }}
                      </div>
                    </div>
                    <v-icon color="primary">
                      {{ 'mdi-checkbox-marked'}}
                    </v-icon>
                  </div>
                </v-sheet>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
        <v-row class="mt-3">
            <v-col cols="6">
              <v-text-field
                v-model="dueDateSelect"
                outlined
                :label="languageSelect === 0 ? 'วันที่' : 'Date'"
                prepend-inner-icon="mdi-calendar"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="dueTimeSelect"
                outlined
                :label="languageSelect === 0 ? 'เวลา *' : 'Time *'"
                prepend-inner-icon="mdi-calendar-clock"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        <v-card-title class="d-flex justify-center">{{ languageSelect === 0 ? 'กรอกรายละเอียด' : 'Fill out the form' }}</v-card-title>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <div v-for="(item, index) in fieldNameItem" :key="index">
                <template
                  v-if="item.conditionField === '' || item.conditionField === null"
                >
                  <v-col
                    class="InputData"
                    cols="12"
                    v-if="item.fieldType == 'text'"
                  >
                    <v-text-field
                      v-if="item.fieldName === 'เบอร์โทร'"
                      v-mask="'###-###-####'"
                      v-model="item.fieldValue"
                      :label="
                        languageSelect === 0 ? item.fieldName : item.fieldNameEn
                      "
                      outlined
                      required
                      :rules="
                        item.requiredField === 'True' ? [rules.required] : [true]
                      "
                      @blur="builValue(item)"
                    >
                      <template v-slot:label v-if="item.requiredField === 'True'"
                        >{{
                          languageSelect === 0
                            ? item.fieldName + "  *"
                            : item.fieldNameEn + "  *"
                        }}
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-else
                      v-model="item.fieldValue"
                      :label="
                        languageSelect === 0 ? item.fieldName : item.fieldNameEn
                      "
                      outlined
                      required
                      :rules="
                        item.requiredField === 'True' ? [rules.required] : [true]
                      "
                      @blur="builValue(item)"
                    >
                      <template v-slot:label v-if="item.requiredField === 'True'"
                        >{{
                          languageSelect === 0
                            ? item.fieldName + "  *"
                            : item.fieldNameEn + "  *"
                        }}
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    class="InputData"
                    cols="12"
                    v-if="item.fieldType == 'Arguments'"
                  >
                  <v-checkbox
                  class="px-4 pr-5 ma-0"
                    v-model="item.fieldValue"
                    :label="languageSelect === 0 ? item.fieldName : item.fieldNameEn"
                    :value="languageSelect === 0 ? 'ตกลง' : 'accept'"
                    required
                      :rules="
                        item.requiredField === 'True' ? [rules.required] : [true]
                      "
                      @change="builValue(item)"
                  >
                  <template v-slot:label v-if="item.requiredField === 'True'">
                    <h6 class="ma-0 mt-1" style="word-wrap: break-word;">{{languageSelect === 0 ? item.fieldName : item.fieldNameEn}}</h6>
                      </template>
                  </v-checkbox>
                    </v-col>
                  <v-col
                    class="InputData"
                    cols="12"
                    v-if="item.fieldType == 'number'"
                  >
                    <v-text-field
                      v-if="item.fieldName === 'เบอร์โทร'"
                      v-mask="'###-###-####'"
                      v-model="item.fieldValue"
                      :label="
                        languageSelect === 0 ? item.fieldName : item.fieldNameEn
                      "

                      outlined
                      required
                      :rules="
                        item.requiredField === 'True' ? [rules.required] : [true]
                      "
                      @blur="builValue(item)"
                      ><template v-slot:label v-if="item.requiredField === 'True'"
                        >{{
                          languageSelect === 0
                            ? item.fieldName + "  *"
                            : item.fieldNameEn + "  *"
                        }}
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-else
                      v-model="item.fieldValue"
                      :label="
                        languageSelect === 0 ? item.fieldName : item.fieldNameEn
                      "

                      outlined
                      required
                      :rules="
                        item.requiredField === 'True' ? [rules.required,rules.numberType] : [true]
                      "
                      @blur="builValue(item)"
                      ><template v-slot:label v-if="item.requiredField === 'True'"
                        >{{
                          languageSelect === 0
                            ? item.fieldName + "  *"
                            : item.fieldNameEn + "  *"
                        }}
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    class="InputData"
                    cols="12"
                    v-if="item.fieldType == 'dateTime'"
                  >
                        <v-menu
            :ref="menudateTime[item.fieldId]"
            v-model="menudateTime[item.fieldId]"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="item.fieldValue"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined

                :label="
                  languageSelect === 0 ? item.fieldName : item.fieldNameEn
                "
                required
                :rules="
                  item.requiredField === 'True' ? [rules.required] : [true]
                "
              >
              <template v-slot:label v-if="item.requiredField === 'True'"
                        >{{
                          languageSelect === 0
                            ? item.fieldName + "  *"
                            : item.fieldNameEn + "  *"
                        }}
                      </template>
              </v-text-field>

            </template>
            <v-date-picker
              v-model="item.fieldValue"
              no-title
              scrollable
              @input="menudateTime[item.fieldId] = false"
            >
            </v-date-picker>
          </v-menu>
                  </v-col>
                  <v-col
                    class="InputData"
                    cols="12"
                    v-if="item.fieldType == 'Autocompletes'"
                  >
                    <v-autocomplete
                      :item-text="languageSelect === 0 ? 'text' : 'textEng'"
                      item-value="value"
                      v-model="item.fieldValue"
                      :items="JSON.parse(item.optionField)"
                      outlined
                      clearable

                      :label="
                        languageSelect === 0 ? item.fieldName : item.fieldNameEn
                      "
                      required
                      :rules="
                        item.requiredField === 'True' ? [rules.required] : [true]
                      "
                      @change="builValue(item)"
                    >
                      <template v-slot:label v-if="item.requiredField === 'True'"
                        >{{
                          languageSelect === 0
                            ? item.fieldName + "  *"
                            : item.fieldNameEn + "  *"
                        }}
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    class="InputData"
                    cols="12"
                    v-if="item.fieldType == 'Selects'"
                  >
                    <v-select
                      class="mb-1"
                      :item-text="languageSelect === 0 ? 'text' : 'textEng'"
                      item-value="value"
                      v-model="item.fieldValue"
                      :items="JSON.parse(item.optionField)"
                      :label="
                        languageSelect === 0 ? item.fieldName : item.fieldNameEn
                      "

                      required
                      clearable
                      :rules="
                        item.requiredField === 'True' ? [rules.required] : [true]
                      "
                      attach
                      outlined
                      :menu-props="{ bottom: true, offsetY: true }"
                      @change="builValue(item)"
                    >
                      <template slot="item" slot-scope="data">
                        <p class="text-wrap" >{{languageSelect === 0 ? data.item.text : data.item.textEng}}</p>
                      </template>
                      <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    class="InputData"
                    cols="12"
                    v-if="item.fieldType == 'Radio'"
                    style="padding:0px;"
                  >
                    <v-container fluid style="padding:0px;">
                      <v-radio-group
                        column
                        v-model="item.fieldValue"

                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                        style="margin:0px;"
                        @change="builValue(item)"
                      >
                        <template v-slot:label> </template>
                        <!-- <h6 class="text-center">{{item.fieldName}}</h6> -->
                        <div
                          class="px-3"
                          v-for="radios in JSON.parse(item.optionField)"
                          :key="radios.toISOString"
                        >
                          <v-radio
                            class="mx-3"
                            :label="
                              languageSelect === 0 ? radios.text : radios.textEng
                            "
                            :value="radios.value"
                          >
                            <template
                              v-slot:label
                              v-if="item.requiredField === 'True'"
                              >{{ radios.text }}
                            </template></v-radio
                          >
                        </div>
                      </v-radio-group>
                    </v-container>
                  </v-col>
                  <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'Checkbox'"
                      style="padding: 0px;"
                    >
                      <div>
                        <p style="text-align: left; display: block; font-size: 16px; margin-bottom: 4px;">
                          {{ languageSelect === 0 ? item.fieldName : item.fieldNameEn }}
                        </p>
                        <div v-for="checkbox in JSON.parse(item.optionField)" :key="checkbox.text" style="text-align: left; margin-bottom: 0px;" class="px-3">
                          <span style="display: none;">{{ item.fieldValue }}</span>
                          <v-checkbox
                            v-model="selected[item.fieldId]"
                            :label="languageSelect === 0 ? checkbox.text : checkbox.textEng"
                            :value="checkbox.value"
                            :rules="item.requiredField === 'True' ? [rules.checkBox] : [true]"
                            @click="item.fieldValue = JSON.stringify(selected[item.fieldId])"
                            class="custom-checkbox ps-3"
                            style="margin-top: 0px;"
                          >
                          </v-checkbox>
                        </div>
                      </div>
                    </v-col>
                </template>
                <template
                  v-if="
                    item.conditionField !== '' &&
                      fieldNameItem.filter(row => {
                        return row.fieldId === parseInt(item.conditionField);
                      }).length > 0
                  "
                >
                  <template
                    v-if="
                      item.conditionValue ===
                        fieldNameItem.filter(row => {
                          return row.fieldId === parseInt(item.conditionField);
                        })[0].fieldValue
                    "
                  >
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'text'"
                    >
                      <v-text-field
                        v-if="item.fieldName === 'เบอร์โทร'"
                        v-mask="'###-###-####'"
                        v-model="item.fieldValue"
                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        outlined
                        required

                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                        @blur="builValue(item)"
                      >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template>
                      </v-text-field>
                      <v-text-field
                        v-else
                        v-model="item.fieldValue"
                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        outlined
                        required

                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                        @blur="builValue(item)"
                      >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                    class="InputData"
                    cols="12"
                    v-if="item.fieldType == 'Arguments'"
                  >
                  <v-checkbox
                  class="px-4 pr-5 ma-0"
                    v-model="item.fieldValue"
                    :label="languageSelect === 0 ? item.fieldName : item.fieldNameEn"
                    :value="languageSelect === 0 ? 'ตกลง' : 'accept'"
                    required
                      :rules="
                        item.requiredField === 'True' ? [rules.required] : [true]
                      "
                      @change="builValue(item)"
                  >
                  <template v-slot:label v-if="item.requiredField === 'True'">
                    <h6 class="ma-0 mt-1" style="word-wrap: break-word;">{{languageSelect === 0 ? item.fieldName : item.fieldNameEn}}</h6>
                      </template>
                  </v-checkbox>
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'number'"
                    >
                      <v-text-field
                        v-if="item.fieldName === 'เบอร์โทร'"
                        v-mask="'###-###-####'"
                        v-model="item.fieldValue"
                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        outlined
                        required

                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                        @blur="builValue(item)"
                      >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template>
                      </v-text-field>
                      <v-text-field
                        v-else
                        v-model="item.fieldValue"
                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        outlined
                        required

                        :rules="
                          item.requiredField === 'True' ? [rules.required,rules.numberType] : [true]
                        "
                        @blur="builValue(item)"
                      >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'dateTime'"
                    >
                    <v-menu
            :ref="menuOptionfield[item.fieldId]"
            v-model="menuOptionfield[item.fieldId]"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="item.fieldValue"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined

                :label="
                  languageSelect === 0 ? item.fieldName : item.fieldNameEn
                "
                required
                :rules="
                  item.requiredField === 'True' ? [rules.required] : [true]
                "
              >
              <template v-slot:label v-if="item.requiredField === 'True'"
                        >{{
                          languageSelect === 0
                            ? item.fieldName + "  *"
                            : item.fieldNameEn + "  *"
                        }}
                      </template>
            </v-text-field>
            </template>
            <v-date-picker
              v-model="item.fieldValue"
              no-title
              scrollable
              @input="menuOptionfield[item.fieldId] = false"
            >
            </v-date-picker>
          </v-menu>
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'Autocompletes'"
                    >
                      <v-autocomplete
                        :item-text="languageSelect === 0 ? 'text' : 'textEng'"
                        item-value="value"
                        v-model="item.fieldValue"

                        :items="JSON.parse(item.optionField)"
                        outlined
                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        required
                        clearable
                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                        @change="builValue(item)"
                      >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'Selects'"
                    >
                      <v-select
                        :item-text="languageSelect === 0 ? 'text' : 'textEng'"
                        item-value="value"
                        class="mb-6"
                        v-model="item.fieldValue"
                        :items="JSON.parse(item.optionField)"
                        :menu-props="{ bottom: true, offsetY: true }"

                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        required
                        clearable
                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                        attach
                        outlined
                        @change="builValue(item)"
                      >
                        <template slot="item" slot-scope="data">
                          <p class="text-wrap" >{{languageSelect === 0 ? data.item.text : data.item.textEng}}</p>
                        </template>
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template>
                      </v-select>
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'Radio'"
                      style="padding:0px;"
                    >
                      <v-container fluid style="padding:0px;">
                        <v-radio-group
                          row
                          v-model="item.fieldValue"

                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                          style="margin:0px;"
                          @change="builValue(item)"
                        >
                          <template v-slot:label> </template>
                          <!-- <h6 class="text-center">{{item.fieldName}}</h6> -->
                          <div
                            v-for="radios in JSON.parse(item.optionField)"
                            :key="radios.toISOString"
                          >
                            <v-radio
                            class="mx-3"
                              :label="
                                languageSelect === 0 ? radios.text : radios.textEng
                              "
                              :value="radios.value"
                              ><template
                                v-slot:label
                                v-if="item.requiredField === 'True'"
                                >{{ radios.text }}
                              </template></v-radio
                            >
                          </div>
                        </v-radio-group>
                      </v-container>
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'Checkbox'"
                      style="padding: 0px;"
                    >
                      <div>
                        <p style="text-align: left; display: block; font-size: 16px; margin-bottom: 4px;">
                          {{ languageSelect === 0 ? item.fieldName : item.fieldNameEn }}
                        </p>
                        <div v-for="checkbox in JSON.parse(item.optionField)" :key="checkbox.text" style="text-align: left; margin-bottom: 0px;" class="px-3">
                          <span style="display: none;">{{ item.fieldValue }}</span>
                          <v-checkbox
                            v-model="selected[item.fieldId]"
                            :label="languageSelect === 0 ? checkbox.text : checkbox.textEng"
                            :value="checkbox.value"
                            :rules="item.requiredField === 'True' ? [rules.checkBox] : [true]"
                            @click="item.fieldValue = JSON.stringify(selected[item.fieldId])"
                            class="custom-checkbox ps-3"
                            style="margin-top: 0px;"
                          >
                          </v-checkbox>
                        </div>
                      </div>
                    </v-col>
                  </template>
                </template>
                <template v-if="item.conditionField === 'flow'">
                  <template
                    v-if="
                      parseInt(item.conditionValue) === parseInt(flowId)
                    "
                  >
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'text'"
                    >
                      <v-text-field
                        v-if="item.fieldName === 'เบอร์โทร'"
                        v-mask="'###-###-####'"
                        v-model="item.fieldValue"

                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                        outlined
                        @blur="builValue(item)"
                      >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template>
                      </v-text-field>
                      <v-text-field
                        v-else
                        v-model="item.fieldValue"

                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                        outlined
                        @blur="builValue(item)"
                      >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                    class="InputData"
                    cols="12"
                    v-if="item.fieldType == 'Arguments'"
                  >
                  <v-checkbox
                  class="px-4 pr-5 ma-0"
                    v-model="item.fieldValue"
                    :label="languageSelect === 0 ? item.fieldName : item.fieldNameEn"
                    :value="languageSelect === 0 ? 'ตกลง' : 'accept'"
                    required
                      :rules="
                        item.requiredField === 'True' ? [rules.required] : [true]
                      "
                      @change="builValue(item)"
                  >
                  <template v-slot:label v-if="item.requiredField === 'True'">
                    <h6 class="ma-0 mt-1" style="word-wrap: break-word;">{{languageSelect === 0 ? item.fieldName : item.fieldNameEn}}</h6>
                      </template>
                  </v-checkbox>
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'number'"
                    >
                      <v-text-field
                        v-if="item.fieldName === 'เบอร์โทร'"
                        v-mask="'###-###-####'"
                        v-model="item.fieldValue"

                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                        outlined
                        @blur="builValue(item)"
                      >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template></v-text-field
                      >
                      <v-text-field
                        v-else
                        v-model="item.fieldValue"

                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        :rules="
                          item.requiredField === 'True' ? [rules.required,rules.numberType] : [true]
                        "
                        outlined
                        @blur="builValue(item)"
                      >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template></v-text-field
                      >
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'dateTime'"
                    >
                    <v-menu
                      :ref="menuOptionfieldFlow[item.fieldId]"
                      v-model="menuOptionfieldFlow[item.fieldId]"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.fieldValue"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined

                          :label="
                            languageSelect === 0 ? item.fieldName : item.fieldNameEn
                          "
                          required
                          :rules="
                            item.requiredField === 'True' ? [rules.required] : [true]
                          "
                        >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                                  >{{
                                    languageSelect === 0
                                      ? item.fieldName + "  *"
                                      : item.fieldNameEn + "  *"
                                  }}
                                </template>
                      </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.fieldValue"
                        no-title
                        scrollable
                        @input="menuOptionfieldFlow[item.fieldId] = false"
                      >
                      </v-date-picker>
                    </v-menu>
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'Autocompletes'"
                    >
                      <v-autocomplete
                        :item-text="languageSelect === 0 ? 'text' : 'textEng'"
                        item-value="value"
                        v-model="item.fieldValue"
                        :items="JSON.parse(item.optionField)"

                        filled
                        clearable
                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                      >
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template></v-autocomplete
                      >
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'Selects'"
                    >
                      <v-select
                        :item-text="languageSelect === 0 ? 'text' : 'textEng'"
                        item-value="value"
                        class="mb-6"
                        v-model="item.fieldValue"
                        :items="JSON.parse(item.optionField)"

                        :menu-props="{ bottom: true, offsetY: true }"
                        :label="
                          languageSelect === 0 ? item.fieldName : item.fieldNameEn
                        "
                        :rules="
                          item.requiredField === 'True' ? [rules.required] : [true]
                        "
                        hide-details
                        outlined
                        clearable
                        attach
                        @change="builValue(item)"
                      >
                        <template slot="item" slot-scope="data">
                            <p class="text-wrap" >{{languageSelect === 0 ? data.item.text : data.item.textEng}}</p>
                        </template>
                        <template v-slot:label v-if="item.requiredField === 'True'"
                          >{{
                            languageSelect === 0
                              ? item.fieldName + "  *"
                              : item.fieldNameEn + "  *"
                          }}
                        </template></v-select
                      >
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'Radio'"
                      style="padding:0px;"
                    >
                      <v-container fluid style="padding:0px;">
                        <v-radio-group
                          row

                          v-model="item.fieldValue"
                          style="margin:0px;"
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                          @change="builValue(item)"
                        >
                          <template v-slot:label> </template>
                          <!-- <h6 class="text-center">{{item.fieldName}}</h6> -->
                          <div
                            v-for="radios in JSON.parse(item.optionField)"
                            :key="radios.toISOString"
                            class="text-center"
                          >
                            <v-radio
                            class="mx-3"
                              :label="
                                languageSelect === 0 ? radios.text : radios.textEng
                              "
                              dense
                              :value="radios.value"
                              ><template
                                v-slot:label
                                v-if="item.requiredField === 'True'"
                                >{{ radios.text }}
                              </template></v-radio
                            >
                          </div>
                        </v-radio-group>
                      </v-container>
                    </v-col>
                    <v-col
                      class="InputData"
                      cols="12"
                      v-if="item.fieldType == 'Checkbox'"
                      style="padding: 0px;"
                    >
                      <div>
                        <p style="text-align: left; display: block; font-size: 16px; margin-bottom: 4px;">
                          {{ languageSelect === 0 ? item.fieldName : item.fieldNameEn }}
                        </p>
                        <div v-for="checkbox in JSON.parse(item.optionField)" :key="checkbox.text" style="text-align: left; margin-bottom: 0px;" class="px-3">
                          <span style="display: none;">{{ item.fieldValue }}</span>
                          <v-checkbox
                            v-model="selected[item.fieldId]"
                            :label="languageSelect === 0 ? checkbox.text : checkbox.textEng"
                            :value="checkbox.value"
                            :rules="item.requiredField === 'True' ? [rules.checkBox] : [true]"
                            @click="item.fieldValue = JSON.stringify(selected[item.fieldId])"
                            class="custom-checkbox ps-3"
                            style="margin-top: 0px;"
                          >
                          </v-checkbox>
                        </div>
                      </div>
                    </v-col>
                  </template>
                </template>
          </div>
        </v-form>
        <div class="">
          <v-btn
          color="primary"
          class="ma-2"
          dark
          @click="internalDialog = false"
        >
        {{ languageSelect === 0 ? 'กลับ' : 'Back' }}
        </v-btn>
        <v-btn
          color="primary"
          class="ma-2"
          dark
          @click="submit"
          :disabled="overlayComponent"
        >
        {{ languageSelect === 0 ? 'ถัดไป' : 'Next' }}
        </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <DialogPreView
      v-model="showDialogPreView"
      :gallery="prodGallery"
    />
  </div>
</template>

<script>
import DialogPreView from './DialogPreView.vue'
export default {
  components: {
    name: '',
    DialogPreView
  },
  name: 'FormBooking',
  props: {
    selectedEmpDetailList: {
      type: Array,
      required: true
    },
    fieldNameItem: {
      type: Array,
      required: true
    },
    languageSelect: {
      type: [String, Number],
      required: true
    },
    flowId: {
      type: [String, Number],
      required: true
    },
    dueDateSelect: {
      type: String,
      default: ''
    },
    dueTimeSelect: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    overlayMain: {
      type: Boolean,
      default: false
    },
    groupFlowId: {
      type: [String, Number],
      required: true
    },
    groupFlow: {
      type: Array,
      required: true
    },
    DataFlow: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showDialogPreView: false,
      prodGallery: [],
      selectedEmpList: [],
      internalDialog: this.value,
      dialogDetails: false,
      valid: true,
      overlayComponent: false,
      rules: {
        checkBox: value => {
          if (value.length < 1) {
            return 'กรุณากรอกข้อมูลอย่างน้อย 1 รายการ'
          }
          return true
        },
        numberType: value => {
          if (isNaN(value)) {
            return 'กรุณากรอกตัวเลขเท่านั้น'
          }

          const parsedValue = parseFloat(value)
          if (!Number.isInteger(parsedValue)) {
            return 'กรุณากรอกตัวเลขเท่านั้น'
          }

          return true
        },
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || '',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  watch: {
    value (val) {
      this.internalDialog = val
    },
    internalDialog (val) {
      this.$emit('input', val) // sync กับ parent
    }
  },
  methods: {
    async openDialogPreView (gallery) {
      this.prodGallery = gallery || []
      if (this.prodGallery.length > 0) {
        this.showDialogPreView = true
      }
    },
    close () {
      this.internalDialog = false
    },
    viewFullImage (imageUrl) {
      this.selectedImage = imageUrl
      this.showFullImage = true
    },
    builValue (item) {
      let data = this.fieldNameItem.filter((i) => parseInt(i.conditionField) === item.fieldId)

      if (data.length > 0) {
        for (let i = 0; i < this.fieldNameItem.length; i++) {
          let fieldItem = this.fieldNameItem[i]
          if (parseInt(fieldItem.conditionField) === item.fieldId && fieldItem.conditionValue !== item.fieldValue) {
            fieldItem.fieldValue = ''
          }
        }
        this.clearConditionStepByStep(data, new Set())
      }
    },
    clearConditionStepByStep (items, checkedItems) {
      items.forEach((item) => {
        if (checkedItems.has(item.fieldId)) {
          return // หากมีการตรวจสอบฟิลด์นี้แล้ว ให้ข้ามไป
        }
        checkedItems.add(item.fieldId) // บันทึกว่าได้ตรวจสอบฟิลด์นี้แล้ว

        for (let i = 0; i < this.fieldNameItem.length; i++) {
          let fieldItem = this.fieldNameItem[i]
          if (parseInt(fieldItem.conditionField) === item.fieldId && fieldItem.conditionValue !== item.fieldValue) {
            fieldItem.fieldValue = ''
          }
        }

        let checkData = this.fieldNameItem.filter((i) => parseInt(i.conditionField) === item.fieldId)
        if (checkData.length > 0) {
          this.clearConditionStepByStep(checkData, checkedItems)
        }
      })
    },
    async submit () {
      this.overlayComponent = true
      console.log('this.overlayComponent2', this.overlayComponent)
      await this.$nextTick() // รอให้ overlay render ก่อน
      const isValid = this.$refs.form.validate()
      if (isValid) {
        await this.emitChange()
        await this.addBooking()
      }
      this.overlayComponent = false
      console.log('this.overlayComponent3', this.overlayComponent)
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    emitChange () {
      const localFieldItems = JSON.parse(JSON.stringify(this.fieldNameItem)) // deep copy เพื่อแก้ไข
      this.$emit('update:fieldNameItem', localFieldItems)
    },
    addBooking () {
      this.$emit('add-booking')
    }
  }
}
</script>
<style scoped>
.InputData {
  margin: 0px !important;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Vela/FormBooking.vue